<div class="modal-header">
  <h5 class="modal-title">Relatório das Orientações</h5>
</div>
<div class="modal-body">
  <div fxLayout="column" fxLayoutAlign="space-between">
    <table mat-table [dataSource]="dataSource" style="width: 100%">
      <!-- name Column -->
      <ng-container matColumnDef="advisor">
        <th mat-header-cell *matHeaderCellDef>Orientador</th>
        <td mat-cell *matCellDef="let element">{{ element.advisor }}</td>
      </ng-container>

      <!-- email Column -->
      <ng-container matColumnDef="student">
        <th mat-header-cell *matHeaderCellDef>Orientando</th>
        <td mat-cell *matCellDef="let element">{{ element.student }}</td>
      </ng-container>

      <!-- profile_type Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Título</th>
        <td mat-cell *matCellDef="let element">
          {{ element.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Descrição</th>
        <td mat-cell *matCellDef="let element">
          {{ element.description }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let element">
          {{ element.date }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
    </table>

    <br />

    <!-- <mat-paginator
      fxLayoutAlign="end end"
      [length]="page.totalElements"
      [pageSize]="page.per_page"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="page.current_page"
      showFirstLastButtons
      (page)="pageEvent = getUsers($event)"
    ></mat-paginator> -->
  </div>
  <div class="modal-footer">
    <button
      mat-raised-button
      type="button"
      class="btn btn-link"
      (click)="dialogRef.close()"
    >
      Voltar
    </button>
  </div>
</div>
